import React from 'react';
import { Button, Icon } from '@vmos2/design-system';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

type Props = {
  disableMyLocation?: boolean,
  form: function,
  getNavigatorGeolocation: function,
  onClick?: function,
};

export const GeoLocationButton = ({ disableMyLocation, form, getNavigatorGeolocation, onClick }: Props): React$Node => {
  const { t } = useTranslation('geoLocation');

  if (disableMyLocation) return null;

  return (
    <StyledButton
      iconLeft={<Icon name="Location" />}
      mode="link"
      mt={2}
      type="button"
      size="small"
      data-test="geolocation-button"
      onClick={async () => {
        form.restart();
        try {
          await getNavigatorGeolocation();
        } catch (e) {
          form.submit();
        }

        if (onClick) onClick();
      }}
    >
      {t('useMyLocation')}
    </StyledButton>
  );
};

const StyledButton = styled(Button)(({ theme }) => `
  text-decoration: none;
  font-size: ${theme.fontSize.sm};

  @media (${theme.breakpoint.tabletLarge}) {
    font-size: ${theme.fontSize.md};
  }
`);
